import { createContext, useContext } from 'react'

import { DocumentListFilterParams, DocumentListResponse } from '~bank-documents/types/documentList'

type DocumentsListContextValue = {
  data: DocumentListResponse
  isPending: boolean
  successFullyLoaded: boolean
  onFilterChange: (filter: Partial<DocumentListFilterParams>) => Promise<void>
  search: DocumentListFilterParams
  invalidate: () => void
  onPageChange: (page: number, size: number) => void
  clear: () => void
}

export const DocumentsListContext = createContext<DocumentsListContextValue | null>(null)

export const useDocumentsListContext = () => {
  const context = useContext(DocumentsListContext)

  if (!context) {
    throw new Error('useDocumentsListContext must be used within a DocumentsListContext.Provider')
  }

  return context
}
